<div>
    <div class="networkinst1" *ngIf="paymentComponentSettings.paymentUrl">
        <iframe id="NIPayment" name="paymentNI" [src]="paymentComponentSettings.paymentUrl | safeUrl" target="_parent" height="650" width="650" frameborder="0" scrolling="no" sandbox="allow-forms allow-popups allow-pointer-lock allow-same-origin allow-scripts allow-top-navigation-by-user-activation allow-top-navigation"></iframe>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/payments/networkinternational.component.html